<template>
  <div>
    <div class="flex-col card_1" @click="jump(detail.id)">
      <div style="height:2.7rem;position: relative">
        <img loading="lazy" :src="detail.pictureUrl ? $imgUrl + detail.pictureUrl : require('../assets/image/login/logo.png')" alt="" class="img_2">
      </div>
      <div class="card-text_1">{{ detail.name }}</div>
      <div v-if="detail.serviceDictValue == 0">
        <div class="flex-row justify-center items-center">
<!--          <div class="card-text_2">电压：{{ voltage }}</div>-->
<!--          <div class="short-line"></div>-->
          <div class="card-text_2">容量：{{ volume }}</div>

        </div>
      </div>
      <div v-else>
        <div class="flex-row justify-center items-center">
          <div class="card-text_2">设备型号：{{ detail.lightingTypeLabel }}</div>
        </div>
      </div>
      <div class="flex-row justify-center items-center">
        <div class="card-text_2">{{ detail.serviceDictValue === 0 ? '台班费' : '单价' }}：{{ detail.price || '暂无'}}</div>
        <div style="width: 30px"></div>
        <div class="card-text_2">销量：{{ detail.num || '暂无'}}</div>
      </div>
<!--      <div class="flex-row justify-center items-center">-->
<!--        <div class="card-text_2">销量：{{ detail.num || '暂无'}}</div>-->
<!--      </div>-->
      <div class="flex-row justify-center items-center">
        <div class="card-text_2" style="display: flex;">评分：
          <el-rate :value="Number(detail.satisfactionRating)" disabled show-score text-color="#ff9900" score-template=""/>
          <span v-if=" detail.satisfactionRating == null" style="color: #ff9900;">未评分</span>
          <span v-else style="color: #ff9900; font-weight: bold;">{{ detail.satisfactionRating }} 分</span>
        </div>
      </div>
      <div
          style="display: flex;justify-content: center;font-size: 14px;color: #8B8B8B;height: 40px;display: flex;align-items: center;">
        <span>{{ detail.customerName }}</span>
      </div>
      <!--			<div class="card-bottom_1 flex-col justify-between">-->
      <!--				<div class="flex-row  items-center">-->

      <!--					<div class="card-text_4">-->
      <!--            ￥{{ detail.price }}-->
      <!--&lt;!&ndash;						￥{{ detail.serviceType == 0 ? detail.priceGears && detail.priceGears.price : detail.emergencyPrice}}&ndash;&gt;-->
      <!--&lt;!&ndash;						<span v-if="detail.serviceType == 0">/3月</span>&ndash;&gt;-->
      <!--&lt;!&ndash;						<span v-else>/天</span>&ndash;&gt;-->
      <!--					</div>-->
      <!--				</div>-->
      <!--			</div>-->
      <div class=""
           style="font-size: 16px;display: flex;justify-content: space-between;padding:0px 20px 20px;text-align: center;"

      >
        <span v-if="detail.shoppingTrolley == null"
              style="font-size: 14px;background: orange;width: 220px;border-radius: 10px;color: #fff;padding: 2px"
              @click.stop="addEquipment()">加入收藏</span>
        <span v-else
              style="font-size: 14px;background: orange;width: 220px;border-radius: 10px;color: #fff;padding: 2px"
              @click.stop="deleteGood">已收藏</span>

      </div>

      <!--      <div style="margin: 0 auto;padding:0px 20px 20px" v-else @click.stop>-->
      <!--        <el-input-number @change="updataNum()" size="mini" :min="1" v-model="detail.shoppingTrolley.number"></el-input-number>-->
      <!--      </div>-->

    </div>
    <!--    <el-dialog-->
    <!--        :visible.sync="dialogVisible"-->
    <!--        width="50%"-->
    <!--        :before-close="handleClose">-->
    <!--      <div style="display: flex">-->
    <!--        <img src="../assets/image/img_1.png" class="img_2" style="width: 225px;height: 167px">-->
    <!--        <div class="rightMessage">-->
    <!--          <div class="card-text_1" style="font-size: 20px">{{detail.title}}</div>-->
    <!--          <div class="card-text_4">-->
    <!--            ￥{{ detail.price }}-->

    <!--&lt;!&ndash;            ￥{{ detail.serviceType == 0 ? detail.priceGears && detail.priceGears.price : detail.emergencyPrice}}&ndash;&gt;-->
    <!--&lt;!&ndash;            <span v-if="detail.serviceType == 0">/3月</span>&ndash;&gt;-->
    <!--&lt;!&ndash;            <span v-else>/天</span>&ndash;&gt;-->
    <!--          </div>-->
    <!--          <div class="info-intro flex-row">-->
    <!--            <div class="listItem"> <label>提供人姓名:</label> <span>{{detail.name}}</span> </div>-->
    <!--            <div class="listItem"> <label>设备类型:</label> <span>{{detail.typeName}}</span> </div>-->
    <!--            <div class="listItem"> <label>设备容量:</label> <span>{{detail.volume}}</span> </div>-->
    <!--            <div class="listItem"> <label>设备地点:</label>-->
    <!--              <span>{{(detail.provinceName + detail.cityName + detail.countyName) || '未知'}}</span>-->
    <!--            </div>-->
    <!--            <div class="listItem"> <label>输出电压</label> <span>{{detail.voltage}}</span> </div>-->
    <!--          </div>-->
    <!--          <div >-->
    <!--            数量：<el-input-number  v-model="num"  @change="updataNum()" :min="1" :max="100" label="数量"></el-input-number>-->
    <!--          </div>-->
    <!--        </div>-->
    <!--      </div>-->
    <!--      <span slot="footer" class="dialog-footer">-->
    <!--        <el-button @click="dialogVisible = false">取 消</el-button>-->
    <!--        <el-button type="primary" @click="dialogVisible = false" >确 定</el-button>-->
    <!--      </span>-->
    <!--    </el-dialog>-->
    <loginDia
        :dialogShow.sync="dialogShow"
    ></loginDia>
  </div>
</template>

<script>
import {addEquipmentApi, getDicts, deleteGoodApi} from "@/http/api/ordinary";
import loginDia from "@/components/ordinary/loginDia.vue";
import {getDictByType} from "@/utils/dictUtils";

export default {
  name: 'homeListCard',
  components: {loginDia},
  props: {
    detail: {
      type: Object,
      default: {}
    },
    type: {
      type: Number,
      default: 0
    },
    changeEq: {
      type: String,
      default: "0"
    },
    getDictValueByTypeAndValue:{
      type: Function,
      default: function (type, value) {
        return value;
      }
    }
  },
  watch: {
    "detail.id": function (val) {
      this.dict();
    }
  },
  created() {
    this.dict()
  },
  dicts: ['voltage_kv', 'volume_kva'],
  data() {
    return {
      dialogVisible: false,
      num: 1,
      dialogShow: false,
      voltage: '',
      volume: '',
      lightValue:'',
    };
  },
  methods: {

    dict() {
      this.voltage = this.getDictValueByTypeAndValue("voltage_kv",this.detail.voltageDictValue)

      /*getDictByType(
          'voltage_kv'
      ).then(res => {
        let data = res.find(item => item.dictValue === this.detail.voltageDictValue)
        if (data) {
          this.voltage = data.dictLabel
        }
        // this.voltage = res.find(item=>item.dictValue === this.detail.voltageDictValue).dictLabel
      })*/

      this.volume = this.getDictValueByTypeAndValue("volume_kva",this.detail.volumeDictValue)
      /*getDictByType('volume_kva').then(res => {

        let data = res.find(item => item.dictValue === this.detail.volumeDictValue)

        if (data) {
          this.volume = data.dictLabel
        }
      })*/


      // this.lightValue = this.detail.lightingTypeLabel

      /*getDictByType(
          'lighting_type'
      ).then(res => {
        let data = res.find(item => item.dictValue === this.detail.lightingTypeValue)
        if (data) {
          this.lightValue = data.dictLabel
        }
        // this.voltage = res.find(item=>item.dictValue === this.detail.voltageDictValue).dictLabel
      })*/

    },

    // 移除设备
    deleteGood(id) {
      deleteGoodApi(
          this.detail.shoppingTrolley.id
      ).then(res => {
        this.$message({
          type: 'success',
          message: '设备移除成功'
        })
        this.$emit('updataState')
      })
    },

    addEquipment() {
      if (!this.$store.state.token) {
        this.dialogShow = true
        return
      }
      addEquipmentApi({
        archiveId: this.detail.id,
        number: 1
      }).then(res => {
        this.$message({
          message: '当前设备已加入设备列表',
          type: 'success'
        });
        this.$emit('updataState')
      })
      // location.reload()
    },

    updataNum(val) {
      addEquipmentApi({
        id: this.detail.shoppingTrolley.id,
        number: this.detail.shoppingTrolley.number
      }).then(res => {

      })
    },
    // 购物车弹窗关闭
    handleClose() {
      this.dialogVisible = false
      this.num = 1
    },
    // 商品弹窗购物车
    showDia(val) {
      this.dialogVisible = true

    },

    jump(id) {
      // 使用 resolve 获取路由的完整 URL
      const routeData = this.$router.resolve({
        path: '/ordinaryUser/rentDetail',
        query: {
          id: id,
          changeEq: this.changeEq
        }
      })

      // 在新窗口打开完整 URL
      window.open(routeData.href, '_blank')

      /*this.$router.push({
        path: '/ordinaryUser/rentDetail',
        query: {
          id: id,
          changeEq: this.changeEq
        }
      })*/


      // if (this.type == 0) {
      // 	this.$router.push({
      // 		path: '/ordinaryUser/rentDetail',
      // 		query: {
      // 			id: id,
      // 			changeEq: this.changeEq
      // 		}
      // 	})
      // }
      // if (this.type == 1) {
      // 	this.$router.push({
      // 		path: '/ordinaryUser/emergencyDetail',
      // 		query: {
      // 			id: id,
      // 			changeEq: this.changeEq
      // 		}
      // 	})
      // }
    }
  }

}
</script>

<style scoped>
.scope-box {
  display: flex;
  background-color: red;
  height: 40px;
}

.card_1 {
  width: 2.7rem;
  background: #FFFFFF;
  border-radius: .06rem;
  margin-bottom: 20px;
  /* margin-right: .22rem; */
  box-sizing: border-box;
  text-align: center;
  cursor: pointer;
  margin-right: 12px;
}

.card_1 .img_2 {

  max-width: 2.7rem;
  max-height: 2.7rem;
  width: auto;
  height: auto;
  display: block;
  position: absolute;
  top: 50%;
  left: 50%;
  margin: 0 auto;
  transform: translate(-50%,-50%);
  border-radius: 0.06rem;
}

.card_1 .card-text_1 {
  display: flex;
  align-items: center;
  margin: 0 auto;
  font-size: 16px;
  font-family: PingFang SC-Medium, PingFang SC;
  font-weight: 500;
  color: #000000;
  line-height: .2rem;
  text-align: center;
  padding: .16rem 0 .14rem;
  height: 48px;
  line-height: 20px;
}

.card_1 .card-text_2 {
  font-size: .13rem;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: #8D8D8D;
  line-height: .25rem;
}

.card_1 .short-line {
  width: .01rem;
  height: .08rem;
  background-color: #BABABA;
  margin: .06rem .16rem .04rem;
}

.card_1 .card-bottom_1 {

  padding: .16rem .14rem .17rem;
  //margin-top: .16rem;
  border-top: 1px dashed #F3F3F3;
}

.card_1 .card-text_3 {
  font-size: .13rem;
  font-family: PingFang SC-Regular, PingFang SC;
  color: #8B8B8B;
  line-height: .18rem;
  margin-right: .09rem;
}

.card_1 .xingxing {
  width: .15rem;
  height: .15rem;
  margin-right: .06rem;
  background: url('../assets/image/star_2.png') no-repeat;
  background-size: 100% 100%;
}

.card_1 .active {
  background: url('../assets/image/star_1.png') no-repeat;
  background-size: 100% 100%;
}

.card_1 .text-score {
  font-size: .13rem;
  font-family: PingFang SC-Regular, PingFang SC;
  color: #FF7E36;
  line-height: .18rem;
  margin-left: .04rem;
}

.card_1 .card-text_5 {
  font-size: .13rem;
  font-family: PingFang SC-Regular, PingFang SC;
  color: #8B8B8B;
  line-height: .18rem;
  padding-top: .03rem;
}

.card_1 .card-text_4 {
  width: 100%;
  text-align: center;
  font-size: .16rem;
  font-family: PingFang SC-Medium, PingFang SC;
  font-weight: 500;
  color: #FF4747;
  line-height: .22rem;
}

.rightMessage {
  margin-left: 0.5rem;
}

.rightMessage .card-text_4 {
  font-size: .16rem;
  font-family: PingFang SC-Medium, PingFang SC;
  font-weight: 500;
  color: #FF4747;
  line-height: .22rem;
}

.info-intro {
  flex-wrap: wrap;
  padding: .1rem 0;
  background-color: #FFFDFC;

  .listItem {
    width: calc(50% - .4rem);
    line-height: 0;
    padding: .15rem .1rem;

  }
}
</style>
